export default __webpack_public_path__ + "static/insurance_website-11006b104ad61211242297085c1c2e40.png";